<template>
  <Row>
    <Col span="24">
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp"> 发布时间：2022-07-07 </span>
        </div>
        <div class="div_img01" v-for="(item, index) in img" :key="index">
          <span
            v-if="item.sp !== ''"
            :src="item.sp"
            style="
              font-size: 17px;
              font-weight: bold;
              color: #70a9f8;
              line-height: 34px;
            "
            >{{ item.sp }}</span
          >
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
          <img
            v-if="item.imgUrl02 !== ''"
            :src="item.imgUrl02"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl03 !== ''"
            :src="item.imgUrl03"
            alt="暂无照片"
          />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title: "热烈欢迎陕西省宝鸡市港务区领导莅临南秀科技参观指导！",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsSeven/01.jpg",
          imgUrl02: "",
          imgUrl03: "",
          p: "7月22日下午，陕西省宝鸡市港务区调研团队莅临智慧岛大厦及南秀科技参观指导，领导们在四楼听取了创意岛孵化器运营情况。",
        },
        {
          imgUrl: "../../../static/img/News/NewsSeven/02.jpg",
          imgUrl02: "../../../static/img/News/NewsSeven/03.jpg",
          imgUrl03: "../../../static/img/News/NewsSeven/04.jpg",
          p: "南秀科技负责人王鹏超向领导们介绍公司经营历程，经营成果以及所获荣誉，还详细介绍了公司主要科技产品智慧工地管理平台。",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 100%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}

.div_img01 img {
  width: 96%;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsSeven.vue